import './verify.scss';
import React, { useState }                     from 'react';
import { Link, useHistory } from 'react-router-dom';
import { getProfile, register, verify } from '../../../shared/services/user/user-service';
import { getLocalStorage, updateLocalStorage } from '../../../shared/services/general/general-service';
import { variable_names } from '../../../shared/services/general/configs';
import Box                                     from '@material-ui/core/Box';
import Countdown                               from '../../../components/countdown/countdown';
import Button                                  from '@material-ui/core/Button';
import { Icon }                                from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import { useConfigApp } from '../../../shared/services/general/app-context';
import OTPInput from '../../../components/otp/otp-input';
import { useDispatch, useSelector } from 'react-redux';
import profileActions from '../../../store/actions/profile.action';

export function VerifyForm ({ onClose, isModal, openRegisterDialog }) {
	const { profile }                                 = useSelector(state => state.profileData);
	const dispatch                                    = useDispatch();
	const [error, setError] = useState(null);
	const [message, setMessage] = useState(null);
	const configApp = useConfigApp();
	const history = useHistory();

	const handleOtpComplete = (otpValue) => {
		setMessage('در حال بررسی کد وارد شده')
		verify(otpValue, getLocalStorage(variable_names.principal), getLocalStorage(variable_names.token, true)).then(
			(result) => {
				let response = result.data;
				if (result.status === 200 && response.code === 200) {
					let token = response.data[ 'token' ];
					updateLocalStorage(variable_names.token, token, true);
					updateLocalStorage(variable_names.user_is_login, true);
					sessionStorage.removeItem('myPhoneNumber')
					setMessage(null)
					if (isModal) {
						onClose();
						if (JSON.stringify(profile) === '{}' || !profile) {
							let data = response.data[ 'userProfile' ];
							dispatch(profileActions(data));
						}
					} else {
						history.push('/');
						if (JSON.stringify(profile) === '{}' || !profile) {
							let data = response.data[ 'userProfile' ];
							dispatch(profileActions(data));
						}

					}
				}
			}
		).catch(
			(error) => {
				let response = error.response.data;
				setError(response.message)
				setMessage(null)
			}
		);
	};

	const setPhoneNumber = () => {
		sessionStorage.setItem('myPhoneNumber', getLocalStorage(variable_names.principal));
	}

	const resendCode = () => {
		return register(getLocalStorage(variable_names.principal));
	};

	const handleOutsideClick = () => {
		onClose();
	};

	const handleInsideClick = (e) => {
		e.stopPropagation();
	};

	return (
		<Box className="verify-container">
			<div className='verify-form' onClick={handleOutsideClick}>
				<div onClick={handleInsideClick}>
					<h1>{configApp?.title}</h1>
					<div className='message'>
						<span>کد ارسال شده به شماره زیر را وارد کنید</span>
					</div>
					<div className='sub-message'>
						<div className='phone-show'>
							<span>{getLocalStorage(variable_names.principal)}</span>
						</div>
						<Box className='other-operation items-center'>
							{isModal ?
								<Button variant={'text'}
										onClick={() => {
											// setOpenRegisterDialog(true);
											setPhoneNumber()
											if (isModal) {
												onClose();
												openRegisterDialog(true)
											}
										}}>
									<Icon component={EditIcon} fontSize={'small'} />
									<span style={{ marginRight: '5px' }}>اصلاح شماره</span>
								</Button> :
								<Link className="items-center" to={'/register'} onClick={setPhoneNumber}>
									<Icon component={EditIcon} fontSize={'small'} />
									<span style={{ marginRight: '5px' }}>اصلاح شماره</span>
								</Link>}
						</Box>
					</div>
					<OTPInput length={5} onComplete={handleOtpComplete} />
					{error &&
						<p style={{ color: 'red', fontSize: '12px', marginTop: '8px', direction: 'rtl', }}>{error}</p>}
					{message && <p style={{
						color: '#fff',
						fontSize: '12px',
						marginTop: '8px',
						direction: 'rtl',
					}}>{message}</p>}
					<div className='countdown'>
						<Countdown initialTime={120}
								   resetFunc={resendCode} />
					</div>
				</div>
			</div>
		</Box>
	);
}

export default function VerifyContent({ onClose, isModal = false, openRegisterDialog }) {
	return (
		<>
			<VerifyForm onClose={onClose}
						openRegisterDialog={openRegisterDialog}
						isModal={isModal} />
		</>
	);
}
